

export function formatDMY(dateStr) {
  if (!dateStr) return "";

  
  if (!isNaN(dateStr)) {
    if (dateStr.toString().length === 10) dateStr *= 1000; 
    const d = new Date(dateStr);
    return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
  }

  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
}

